import { Component, OnInit, inject } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import {
    DateSpecificityType,
    decimalMaskNumberConfigOverride,
    integerMaskNumberConfigOverride,
    Locale,
} from '@wdx/shared/utils';
import { BaseWdxFormControlClass } from '../../../abstract-classes/base-form-control.class';
import { IFormDynamicData } from '../../../interfaces';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'wdx-ff-input-control',
    templateUrl: './form-input-control.component.html',
    standalone: false,
})
export class FormInputControlComponent
    extends BaseWdxFormControlClass
    implements OnInit
{
    locale$!: Observable<Locale>;

    integerMaskNumberConfigOverride = integerMaskNumberConfigOverride;
    decimalMaskNumberConfigOverride = decimalMaskNumberConfigOverride;

    readonly INPUT_GROUP_TYPES = [
        this.FormFieldType.Text,
        this.FormFieldType.Decimal,
        this.FormFieldType.Integer,
    ];

    constructor(
        public override controlContainer: ControlContainer,
        public override dynamicDataService: IFormDynamicData,
    ) {
        super(controlContainer, dynamicDataService);
    }

    ngOnInit(): void {
        this.locale$ = this.dynamicDataService.getMeLocale();
        this.locale$.pipe(take(1)).subscribe((locale) => {
            this.integerMaskNumberConfigOverride = {
                ...integerMaskNumberConfigOverride,
                thousands: locale?.numberFormat?.numberGroupSeparator as string,
            };
            this.decimalMaskNumberConfigOverride = {
                ...decimalMaskNumberConfigOverride,
                decimal: locale?.numberFormat?.numberDecimalSeparator as string,
                thousands: locale?.numberFormat?.numberGroupSeparator as string,
            };
        });
        this.translateInitialValue();
    }

    public dateBlurEvent() {
        if (!this.formControl?.pristine) {
            this.formControl?.markAsTouched();
        }
    }

    public mapDateSpecificityType(
        type: DateSpecificityType | undefined,
    ): string {
        switch (type) {
            case DateSpecificityType.TimeDayMonthYear:
                return 'datetime-local';
            case DateSpecificityType.DayMonthYear:
                return 'date';
            case DateSpecificityType.MonthYear:
                return 'month';
            case DateSpecificityType.Year:
                return 'text';
            default:
                return 'date';
        }
    }

    private translateInitialValue(): void {
        const value = this.formControl?.value;
        if (typeof value !== 'string' || !value) {
            return;
        }

        const translated =
            this.translationsService.translateTokenisedString(value);
        if (translated && translated !== value) {
            this.formControl?.setValue(translated, { emitEvent: false });
        }
    }
}
